import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {MessageStatus, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-message-status-icon',
    templateUrl: './message-status-icon.component.html',
    styleUrls: ['./message-status-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageStatusIconComponent {
  @Input() messageStatus: TaskMessageStatus | MessageStatus;

  get backgroundColorClass(): string {
    switch (this.messageStatus) {
      case TaskMessageStatus.UNKNOWN: return "bg-light";
      case TaskMessageStatus.SCHEDULED:
      case TaskMessageStatus.PENDING: return "bg-primary";
      case TaskMessageStatus.WARNING:
      case TaskMessageStatus.DEADLINE_CLOSE:
        return "bg-warning";
      case TaskMessageStatus.REJECTED:
      case TaskMessageStatus.DEADLINE_MISSED:
        return "bg-danger";
      case TaskMessageStatus.ACCEPTED: return "bg-success";
    }
    return "";
  }
}
